export default theme => ({
  wrapper: {
    padding: '0 15px 25px'
  },
});
